/*
 pageHeader

 This component represents the page header for the application

 */

import $ from 'jquery';
import ko from 'knockout';
import { authService } from '../login';
import { logOutUser } from '../session';
import { featuresRepo } from './featuresRepo';

ko.components.register('page-header', {
    viewModel: pageHeader,
    template: {
        element: 'page-header-template'
    }
});


function pageHeader(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof pageHeader)
        return data;

    //Base props
    self.loading = ko.observable(false);
    self.selected = ko.observable(data.selected);
    self.ssoUrls = ko.observable(null);
    self.loginUser = ko.observable("");
    self.showUserMenu = ko.observable(false);
    self.showSupportInfo = ko.observable(false);
    self.supportInfo = ko.observable("");
    self.dataProcessHasErrors = ko.observable(false);
    self.dataProcessCurrentlyRunning = ko.observable("");
    self.dataProcessesArePending = ko.observable(false);
    self.enableDataProcessNotifications = ko.observable(false);
    self.isAdminUser = ko.observable(false);
    self.userPermissions = ko.observable([]);
    self.showPasswordDialog = ko.observable(false);
    self.newPassword1 = ko.observable("");
    self.newPassword2 = ko.observable("");
    self.enableVoidMatrix = ko.observable(false); //default to false until request returns with features
    self.enableBudgets = ko.observable(false); //default to false until request returns with features

    //Public functions

    self.logOut = function () {
        logOutUser();
    }

    self.togglePasswordDialog = function () {

        if (self.showPasswordDialog()) {
            self.showPasswordDialog(false);
        }
        else {
            self.showUserMenu(false);
            self.showPasswordDialog(true);
        }

        return true;
    }

    self.checkNewPassword = function () {
        if (self.newPassword1() == self.newPassword2()) {
            document.getElementById("divSecondPassword").className = "";
            document.getElementById("txtNoMatch").style.visibility = 'hidden';
            document.getElementById("btnSaveNewPassword").style.visibility = 'visible';
            return true;
        }
        else {

            document.getElementById("divSecondPassword").className = "form-group has-error has-feedback";
            document.getElementById("txtNoMatch").style.visibility = 'visible';
            document.getElementById("btnSaveNewPassword").style.visibility = 'hidden';
            return false;
        }
    }

    self.saveNewPassword = function () {
        if (self.checkNewPassword()) {
            //post to server
            authService.changePassword(self.newPassword1()).then(function (data) {
                if (data == "200") {
                    alert('Your password has been changed.  You will now be logged out.  Please login using your new password.');
                    logOutUser();
                }
            });
        }
    }

    self.passwordDialogClosed = function () {
        self.showPasswordDialog(false);
    }


    self.openUserMenu = function () {
        if (!self.showUserMenu()) {
            self.loading(true);
            self.showUserMenu(true);

            authService.getSsoUrls().then(self.ssoUrls).finally(() => self.loading(false));

            //If the user clicks outside of the user menu, hide it
            $(document).on("mouseup.userMenu", function (event) {
                var $clickedEl = $(event.target);
                if (!$clickedEl.parents('#page-header-user-menu').length > 0) {
                    self.showUserMenu(false);
                    $(document).off('mouseup.userMenu')
                }
            });
        }
    }

    self.onClickDataProcessingStatus = function () {
        var url = window.location.href;
        url = url.substring(0, url.lastIndexOf("/"));
        url += "/dataProcessingStatus.html";
        window.location.href = url;
    }

    var getSupportInfo = function () {

        self.showSupportInfo(false);

        authService.getSupportInfo().then(
            function (response) {

                var supportInfo = response;
                if (supportInfo && supportInfo.length > 0) {
                    self.supportInfo(supportInfo);
                    self.showSupportInfo(true);
                }
            },
            function (errorResult) {
            }
        );
    };

    self.getDataProcessingCurrentStatus = function () {

        self.dataProcessHasErrors(false);
        self.dataProcessCurrentlyRunning("");
        self.dataProcessesArePending(false);

        authService.getDataProcessingCurrentStatus().then(
            function (response) {

                var statusObj = response;
                if (statusObj) {

                    self.dataProcessCurrentlyRunning(statusObj.processCurrentlyRunning || "");

                    if (statusObj.errorsOccurredRecently === true)
                        self.dataProcessHasErrors(true);

                    if (statusObj.processesArePending === true)
                        self.dataProcessesArePending(true);

                    self.enableDataProcessNotifications(statusObj.enableStatusNotifications || false);
                }
            },
            function (errorResult) {
            }
        );
    };

    //Private functions
    var init = function () {

        if (self.selected() === "ForgotLogin" || self.selected() === "ResetPassword")
            return;

        var currentUrl = window.location.href;

        //Check to see if we're coming from Trackmax
        if (window.location.search.indexOf("fromtrackmax=1") > 0) {

            currentUrl = currentUrl.replace("?fromtrackmax=1", "?");
            currentUrl = currentUrl.replace("&fromtrackmax=1", "");

            //Store the current url so that the login page can redirect later.
            localStorage.setItem("loginRedirect", currentUrl);

            //Redirect to login page
            var loginUrl = currentUrl.substring(0, currentUrl.lastIndexOf("/"));
            loginUrl += "/login.html";
            window.location.href = loginUrl;
            return;
        }

        var loginUser = authService.getLoginUser();
        if (loginUser && loginUser.length > 0)
            self.loginUser(loginUser);

        var isAdmin = authService.isAdminUser();
        self.isAdminUser(isAdmin);
        self.userPermissions(authService.userPermissions());

        featuresRepo.getFeatures().then(
            function (result) {
                if (result && result.enableVoidMatrix)
                    self.enableVoidMatrix(result.enableVoidMatrix);

                if (result && result.enableBudgets)
                    self.enableBudgets(result.enableBudgets);
            },
            function (err) {
            }
        );

        if (!(data.active ?? true)) return;

        getSupportInfo();
        self.getDataProcessingCurrentStatus();

        setInterval(function () {
            self.getDataProcessingCurrentStatus();
        }, 60000);
    };

    //Init the UI
    init();
}
